module.exports = __webpack_public_path__ + "img/1580625498.e3a302f3.jpg";